import firebase from 'firebase';
import { UserRole } from './UserRoles';
import { plainToClass } from 'class-transformer';

interface IUser {
  uid: string;
  email: string;
  displayName: string;
  photoUrl: string;
  role: UserRole;
}

class User {
  public uid!: string;
  public email!: string | '';
  public displayName!: string;
  photoUrl = '';
  public role = UserRole.INSTRUCTOR;

  static fromAuthClient(user: firebase.User): User {
    return plainToClass(User, {
      uid: user.uid,
      email: user.email || '',
      displayName: user.displayName || '',
      photoUrl: user.photoURL || ''
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static fromJson(user: any): User {
    // currently the api will return photoUrl as null which causes
    // class-transformer to not apply a default value
    // this explicit check is necessary until the api sanitizes to non-null
    if (user.photoUrl === null) {
      user.photoUrl = undefined;
    }
    return plainToClass(User, user, { exposeDefaultValues: true });
  }
}

export { User, IUser };
